import React from "react";
import { MidiDevicePanel } from "../midi/MidiDevicePanel";
import { RydCollapsableCard } from "../widgets/RydCollapsableCard";
import { CollapsablePanel } from "./CollapsablePanel";
import './LibraryPanel.css';
import { SamplesBrowser } from "../dialogs/browsers/SamplesBrowser";
import { Midi } from "@tonejs/midi";
import {
    readMidiFileAsHNCs,
    RydBasicTrackMetadata
} from "../../utils/RydMidiConverter";
import { addLoopTrack } from "../../services/ProjectTracksService";
import { RydProject } from "../../model/project";
import { useMixerStore } from "../../stores/MixerStore";
import {
    useSetWorkspaceComputedContextFrame,
    useSetWorkspaceContextPlane,
    useSetWorkspaceLines,
    useSetWorkspaceTracks,
    useSetWorkspaceUIState
} from "../../stores/WorkspaceStore";
import { RydFeatures } from "../../utils/FeatureToggle";
import { BookmarksBrowser } from "../dialogs/browsers/BookmarksBrowser";


const expandWidth: React.CSSProperties = {
    width: '100%',
};

export function LibraryPanel({
    isCollapsed,
    toggleCollapse,
    project,
    // setProject,
}: {
    isCollapsed: boolean,
    toggleCollapse: () => void,
    project: RydProject,
    // setProject: (project: any) => void,
}) {

    const mixerStore = useMixerStore();
    const setWorkspaceUIState = useSetWorkspaceUIState();
    const setWorkspaceTracks = useSetWorkspaceTracks();
    const setWorkspaceComputedContextFrame = useSetWorkspaceComputedContextFrame();
    const setWorkspaceContextPlane = useSetWorkspaceContextPlane();
    const setWorkspaceLines = useSetWorkspaceLines();


    const setProject = (project: RydProject) => {
        setWorkspaceTracks(new Map(project.tracks));
        setWorkspaceContextPlane({stateObject: project.contextFrame.grid});
        setWorkspaceComputedContextFrame(project.contextFrame.computed);
        setWorkspaceLines([...project.getAll()]);
    };

    const libraryItems : {
        title: string,
        el: React.ReactElement
    }[] = [];

    if (RydFeatures.Toggle.isOn('LIBRARY_BOOKMARKS')) {
        libraryItems.push({
            title: 'Bookmarks',
            el: <BookmarksBrowser />
        });
    }

    if (RydFeatures.Toggle.isOn('LIBRARY_PALETTE')) {
        libraryItems.push({
            title: 'Local samples',
            el: <SamplesBrowser
                className="interaction-panel"
                style={{ maxHeight: '400px', width: '360px', fontSize: '8pt' }}
                includeMetadata
                onSelectFile={(file, adapter) => {
                    console.log('Selected file:', file.path);
                    adapter.readFile(file.path, 'arrayBuffer').then((data) => {
                        console.log('File data (ArrayBuffer):', data);
                        if (!(data instanceof ArrayBuffer)) {
                            console.error('Data is not an ArrayBuffer', data);
                            return;
                        }
                        const midi = new Midi(data);
                        const hncs: RydBasicTrackMetadata[] = readMidiFileAsHNCs(midi);
                        console.log('Parsed MIDI:', hncs);

                        addLoopTrack(project, hncs[0].hnc, setProject, mixerStore, setWorkspaceUIState);
                        setProject(project);
                    }).catch((err) => {
                        console.error('Error reading file:', err);
                    });
                }}
            />
        });
    }

    libraryItems.push({ title: 'MIDI', el: <MidiDevicePanel /> });

    return (
        <CollapsablePanel
            isCollapsed={isCollapsed}
            toggleCollapse={toggleCollapse}
            extraClasses={['ryd-library-panel']}>

            {libraryItems.map((item, index) => (
                <RydCollapsableCard title={item.title} key={index} collapsed={true} style={expandWidth}>
                    {item.el}
                </RydCollapsableCard>
            ))}
        </CollapsablePanel>
    );
}